(function () {
	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass('slider_started')){
				return ''
			}
			$(this).addClass('slider_started');
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");

			// Date filtering logic BEFORE Swiper initialization
			let utcDate = new Date();
			let pstDate = utcDate.toLocaleString("en-US", {timeZone: "America/Los_Angeles"})
			let date = new Date(pstDate);
			let today = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear();
			let slides = box.find(".swiper-slide");
			for (let i = 0; i < slides.length; i++) {
				let slide = slides[i];
				let startDate = slide.getAttribute("startdate");
				let endDate = slide.getAttribute("enddate");
				if(startDate){
					let todayDate = new Date(today);
					let startDateObj = new Date(startDate)
					if(startDateObj > todayDate){
						slide.style.display = "none";
					}
				}
				if(endDate){
					let todayDate = new Date(today);
					let endDateObj = new Date(endDate)
					if(endDateObj < todayDate){
						slide.style.display = "none";
					}
				}
			}
			// Reveal the slideshow after filtering
			setTimeout(function() {
				box[0].style.opacity = 1;
			}, 500);

			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			} else {
				autoplayParm = {};
			}
			let swiperParms = {
				speed: box.data("speed") * 1000,
				effect: box.data("effect"),
				loop: true,
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				allowTouchMove: false,
				preventClicks: false,
				preventClicksPropagation: true,
				creativeEffect: {
					prev: {
						shadow: true,
						translate: [0, 0, -400],
					},
					next: {
						translate: ["100%", 0, 0],
					},
				},
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: true,
				},
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				...autoplayParm,
			};
			const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);
			colorScheme(swiper);
			swiper.on("beforeTransitionStart", function () {
				colorScheme(this);
			});

			$(box).find('.slideshow-slide__content').on('click', function(e) {
				const href = $(this).data('href');
				if (href) {
					window.location.href = href;
				}
			});

			$(box).find('.slideshow-slide__content[data-href]').css('cursor', 'pointer');

			function colorScheme(context) {
				const parent = $(context.el).parent();
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const changeItems = [
					context.navigation.nextEl,
					context.navigation.prevEl,
					context.pagination.el,
				];
				const colorScheme = $(activeSlide)
					.find(".slideshow-slide")
					.data("color-scheme");
				changeItems.forEach((item) => {
					$(item)
						.removeClass("color-background-1")
						.removeClass("color-background-4")
						.addClass(colorScheme);
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();
